export default "__VITE_ASSET__$5_aAixy__"